import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { McpStepUpPage } from '../features/mcp/step-up-page';

const searchSchema = z.object({
  ticket: z.string().optional(),
});

function McpStepUpRoute() {
  const { ticket } = Route.useSearch();
  return <McpStepUpPage ticket={ticket} />;
}

export const Route = createFileRoute('/account/mcp/step-up')({
  validateSearch: searchSchema,
  component: McpStepUpRoute,
});
